import React, { useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Col, ErrorModal, Modal, Row } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { syncToLegalDeposits } from "../../api/adminService";
export var LegalDepositsSynchronize = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var _b = useState(false), errorModalOpen = _b[0], setErrorModalOpen = _b[1];
    var _c = useState(""), message = _c[0], setMessage = _c[1];
    var _d = useState(""), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useMutation(function () { return syncToLegalDeposits(ky); }, {
        onSuccess: function (result) {
            setMessage(formatMessage({ id: "ui-br-users.admin.sync.legaldeposits.success" }, {
                usersCount: result.usersCount,
                userOrganizationsCount: result.userOrganizationsCount,
            }));
            setModalOpen(true);
        },
        onError: function (error) {
            console.error("Error syncing to legal deposits:", error);
            setErrorMessage(formatMessage({ id: "ui-br-users.admin.sync.legaldeposits.error" }));
            setErrorModalOpen(true);
        },
    }), handleSync = _e.mutate, isLoading = _e.isLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-users.admin.sync.legaldeposits.title", tagName: "h1" }),
        React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "ui-br-users.admin.sync.legaldeposits.title" }), open: modalOpen, onClose: function () { return setModalOpen(false); }, dismissible: true }, message),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-users.admin.sync.legaldeposits.title" }), open: errorModalOpen, content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return handleSync(); }, disabled: isLoading }, isLoading ? (React.createElement(FormattedMessage, { id: "ui-br-users.admin.sync.legaldeposits.button.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-users.admin.sync.legaldeposits.button" })))))));
};
